import { render, staticRenderFns } from "./ReferenceTemplate.vue?vue&type=template&id=fe75283e&"
import script from "./ReferenceTemplate.vue?vue&type=script&lang=js&"
export * from "./ReferenceTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports